import { PropertyType, PropertyTypeValue } from '@/models/iazi/common/enums';

export const propertyTypeToValue = {
  [PropertyType.House]: PropertyTypeValue.House,
  [PropertyType.Apartment]: PropertyTypeValue.Apartment,
};
